/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { CloudArtifactsPage } from '@/pages/CloudArtifacts/CloudArtifactsPage';

export function ArtifactsBrowserRoute() {
  return <CloudArtifactsPage />;
}
